import { UpdateTypeEnum } from "../enums/UpdateTypeEnum";

export class UpdatePackageAdditionalRequirement {
    public updateType: UpdateTypeEnum = UpdateTypeEnum.Unknown;
    public minVersion: string = "";

    fillFromJson(data: any) {
        this.updateType = data.UpdateType;
        this.minVersion = data.MinVersion;
    }
}
